import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../components/Home.vue'
import TheContainer from '../components/TheContainer.vue'
// login
import Login from '../views/login/Login.vue'
import PostLogin from '../views/login/PostLogin.vue'

// main components
import ProfileTab from '../views/main_components/ProfileTab.vue'
import MessageTab from '../views/main_components/MessageTab.vue'
import HomeTab from '../views/main_components/HomeTab.vue'
import HomeTabNew from '../views/main_components/HomeTab_new.vue'

// create request
import CustomerInfo from '../views/add_request/CustomerInfo.vue'
import Categories from '../views/add_request/Categories.vue'
import Groups from '../views/add_request/Groups.vue'
import SubGroups from '../views/add_request/SubGroups.vue'
import Brands from '../views/add_request/Brands.vue'
import RequestPreDefined from '../views/add_request/RequestPreDefined.vue'
import RequestDetail from '../views/add_request/RequestDetail.vue'
import SignatureRequest from '../views/add_request/RequestSignature.vue'
import RequestAttachments from '../views/add_request/RequestAttachments'
import RequestAddress from '../views/add_request/RequestAddress'
// messenger

// report request
import ReferredRequest from '../views/report_request/ReferredRequests.vue'
import ReportReferredRequest from '../views/report_request/ReportReferredRequests.vue'
import ViewRequest from '../views/report_request/ViewRequestDetail.vue'
import ViewPreRequest from '../views/report_request/ViewPreRequestDetail.vue'
import SafirDevices from '../views/report_request/SafirDevices'
import RequestAddPriceResult from '../views/report_request/RequestAddPriceResult'
import ViewRequestAllAttachments from '../views/report_request/ViewRequestAllAttachments'

// messenger
import ChatDetail from '../views/messenger/ChatDetail.vue'
import Contacts from '../views/messenger/Contacts.vue'
import AddGroup from '../views/messenger/AddGroup.vue'
import SavedMessage from '../views/messenger/SavedMessage.vue'
import ContactInfo from '../views/messenger/ContactInfo.vue'

// profile
import Setting from '../views/profile/Setting.vue'
import EditProfile from '../views/profile/EditProfile.vue'
import SendSms from '../views/profile/SendSms.vue'
import ChangePassword from '../views/profile/ChangePassword.vue'
import RequestGoodsFactor from '../views/report_request/RequestGoodsFactor'
import RequestGoodsItems from '../views/report_request/RequestGoodsItems'
import InformherItems from '../views/report_request/informher/InformherItems'
import SearchAllRequests from '../views/report_request/SearchAllRequests'
import ViewRequestDetailReadOnly from '../views/report_request/ViewRequestDetailReadOnly'
import ViewPreRequestReadOnly from '../views/report_request/ViewPreRequestReadOnly'

Vue.use(VueRouter)
import i18n from "../i18n";
import ProductFactors from "../views/goodsRequest/ProductFactors";
import ProductFactorItems from "../views/goodsRequest/ProductFactorItems";
import BuyOrders from "../views/buy_orders/BuyOrders";
import BuyOrdersFinalize from "../views/buy_orders/BuyOrdersFinalize";
import RequestQc from "../views/report_request/RequestQc";
import ReminderList from "../views/reminder/ReminderList";
import ReportReminder from "../views/reminder/ReportReminder";
import AddReminder from "../views/reminder/AddReminder";
import AccountingReport from "../views/Report/AccountingReport";
import ViewOnlineRequestRefer from "../views/report_request/ViewOnlineRequestRefer";
import InformHerMasters from "../views/report_request/informher/InformHerMasters";
import MorakhasiComponent from "../views/morakhasi/MorakhasiComponent";
import AddMorakhasi from "../views/morakhasi/AddMorakhasi";
import SipPhone from "../views/siphone/SipPhone";
import AddPreProduct from "@/views/goodsRequest/AddPreProduct.vue";
import RequestPayReport from "@/views/request_pay_report/RequestPayReport.vue";
import Wallet from "@/views/wallet/Wallet.vue";
import InformherAttachments from "@/views/report_request/informher/InformherAttachments.vue";
import RequestReturnedPreDefined from "../views/report_request/RequestReturnedPreDefined.vue";
import RequestOnlinePayments from "../views/report_request/RequestOnlinePayments.vue";
import SurveyReport from "../views/Report/SurveyReport.vue";
const routes = [
  {
    path: '/',
    // Parent must stay unnamed: a named parent with a default child triggers vue-router warnings.
    component: TheContainer,
    children: [
      {
        path: '/',
        redirect:'/home-tab',
        meta: {
          requiresAuth: true,
          name: i18n.t('dashboard')
        },
      },
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/post-login',
        name: 'post_login',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: i18n.t('loginPost')
        },

        component: PostLogin
      },
      {
        path: '/home-tab',
        name: 'home',
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('home')
        },

        component: HomeTab
      },
      
      {
        path: '/home-tab-new',
        name: 'homeNew',
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('home')
        },

        component: HomeTabNew
      },
      {
        path: '/accounting-report',
        name: 'AccountingReport',
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('home')
        },

        component: AccountingReport
      },
      {
        path: '/message-tab',
        name: 'messenger',
        meta: {
          requiresAuth: true,
          name: i18n.t('messenger')
        },

        component: MessageTab
      },
      {
        path: '/profile-tab',
        name: 'profile',
        meta: {
          requiresAuth: true,
          name: i18n.t('profile')
        },
        component: ProfileTab
      },

      {
        path: '/chat-detail',
        name: i18n.t('chats'),
        meta: {
          requiresAuth: true,
          name: i18n.t('chats')
        },

        component: ChatDetail
      },
      {
        path: '/setting',
        name: i18n.t('settings'),
        meta: {
          requiresAuth: true,
          name: i18n.t('settings')
        },
        component: Setting
      },
      {
        path: '/saved-message',
        name: i18n.t('savedMessage'),
        meta: {
          requiresAuth: true,
          name: i18n.t('savedMessage')
        },
        component: SavedMessage
      },
      {
        path: '/contacts',
        name: i18n.t('contacts'),
        meta: {
          requiresAuth: true,
          name: i18n.t('contacts')
        },
        component: Contacts
      },
      {
        path: '/contact-info',
        name: i18n.t('contactInfo'),
        meta: {
          requiresAuth: true,
          name: i18n.t('contactInfo')
        },
        component: ContactInfo
      },
      {
        path: '/add-group',
        name: i18n.t('addGroup'),
        meta: {
          requiresAuth: true,
          name: i18n.t('addGroup')
        },
        component: AddGroup
      },
      {
        path: '/edit-profile',
        name: i18n.t('editProfile'),
        meta: {
          requiresAuth: true,
          name: i18n.t('editProfile')
        },
        component: EditProfile
      },
      {
        path: '/change-password',
        name: i18n.t('changePassword'),
        meta: {
          requiresAuth: true,
          name: i18n.t('changePassword')
        },
        component: ChangePassword
      },
      {
        path: '/send-sms',
        name: i18n.t('sendCode'),
        meta: {
          requiresAuth: true,
          name: i18n.t('sendCode')
        },
        component: SendSms
      },
      {
        path: '/survey_report',
        name: "گزارش نظر سنجی",
        meta: {
          requiresAuth: true,
          name: "گزارش نظر سنجی",
        },
        component: SurveyReport
      },
      {
        path: '/about',
        name: i18n.t('aboutUs'),
        meta: {
          requiresAuth: true,
          name: i18n.t('aboutUs')
        },

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      //* ***************************************************
      //* ***************************************************

      {
        path: '/create-request',
        name: i18n.t('addRequest'),
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('addRequest')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'customer-info',
            name: 'CustomerInfo',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('CustomerInfo')
            },
            component: CustomerInfo
          }, {
            path: 'categories',
            name: 'Categories',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('category')
            },
            component: Categories
          }, {
            path: 'groups',
            name: 'groups',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('group')
            },
            component: Groups
          }, {
            path: 'subgroups',
            name: 'SubGroups',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('subGroup')
            },
            component: SubGroups
          }, {
            path: 'brands',
            name: 'brands',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('brand')
            },
            component: Brands
          }, {
            path: 'predefined',
            name: 'predefined',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('BaseDetail')
            },
            component: RequestPreDefined
          }, {
            path: 'details',
            name: 'request_detail',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('RequestInfo')
            },
            component: RequestDetail
          }, {
            path: 'signature/:rec_id/:type_id',
            name: 'signature',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('CustomerSignature')
            },
            component: SignatureRequest
          }, {
            path: 'attachment/:rec_id',
            name: 'attachment',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('Attachments')
            },
            component: RequestAttachments
          }, {
            path: 'address/:rec_id',
            name: 'requestAddress',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('CustomerAddress')
            },
            component: RequestAddress
          },
        ]
      },
   //* ***************************************************
      {
        path: '/reminder',
        name: "ریمایندر",
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('RequestInfo')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'list',
            name: 'ReminderList',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('referers')
            },
            component: ReminderList
          },
          {
            path: 'add-reminder',
            name: 'AddReminder',
            props: true,
            meta: {
              requiresAuth: true,
              name: i18n.t('refererReport'),
              requiresPost: true,
            },
            component: AddReminder
          },
        ]
      },

      //* ***************************************************
      {
        path: '/report-request',
        name: i18n.t('RequestInfo'),
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('RequestInfo')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'referred-request',
            name: 'ReferredRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('referers')
            },
            component: ReferredRequest
          }, {
            path: 'report-referred-request',
            name: 'ReportReferredRequest',
            props: true,
            meta: {
              requiresAuth: true,
              name: i18n.t('refererReport'),
              requiresPost: true,

            },
            component: ReportReferredRequest
          }, {
            path: 'online-factor',
            name: 'RequestOnlinePayments',
            props: true,
            meta: {
              requiresAuth: true,
              name: "فاکتور آنلاین",
              requiresPost: true,

            },
            component: RequestOnlinePayments
          }, {
            path: 'view-request/:rec_id',
            name: 'ViewRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('showRequest')
            },
            component: ViewRequest
          }, {
            path: 'view-request-read-only/:rec_id/:rec_name',
            name: 'ViewRequestReadOnly',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('showRequest')
            },
            component: ViewRequestDetailReadOnly
          },
          {
            path: 'view-online-request',
            name: 'ViewOnlineRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: "درخواست آنلاین"
            },
            component: ViewOnlineRequestRefer
          },
          {
            path: 'view-pre-request/:rec_id',
            name: 'ViewPreRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('showPreRequest')
            },
            component: ViewPreRequest
          }, {
            path: 'view-pre-request-read-only/:rec_id',
            name: 'ViewPreRequestReadOnly',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('showPreRequest')
            },
            component: ViewPreRequestReadOnly
          }, {
            path: 'add-price-result/:rec_id',
            name: 'RequestAddPriceResult',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('addPayment')
            },
            component: RequestAddPriceResult
          }, {
            path: 'view-request-all-attachments/:rec_id',
            name: 'ViewRequestAllAttachments',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('Attachments')
            },
            component: ViewRequestAllAttachments
          }, {
            path: 'request-goods-factors/:rec_id',
            name: 'RequestGoodsFactors',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('ProductRequests')
            },
            component: RequestGoodsFactor
          }, {
            path: 'request-quality-control/:rec_id',
            name: 'RequestQualityControl',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('qc')
            },
            component: RequestQc
          }, {
            path: 'request-goods-items/:rec_id/:cost_id',
            name: 'RequestGoodsItems',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('ProductRequests')
            },
            component: RequestGoodsItems
          }, {
            path: 'changed-predined-return/:rec_id',
            name: 'RequestReturnedPreDefined',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('ProductRequests')
            },
            component: RequestReturnedPreDefined
          },           {
            path: 'informher-items/:rec_id/:master_id/:doc_type/:editable',
            name: 'InformHerItems',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: 'لیست کالاهای فاکتور'
            },
            component: InformherItems
          },           {
            path: 'informher-attachments/:rec_id/:master_id/:doc_type',
            name: 'InformHerAttachments',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: 'فایل‌های فاکتور'
            },
            component: InformherAttachments
          },
          {
            path: 'inform-her-masters/:req_id',
            name: 'InformHerMasters',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: 'اعلام بها به مشتری'
            },
            component: InformHerMasters
          },
          {
            path: 'safir-devices',
            name: 'SafirDevices',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('DeliveryDevices')
            },
            component: SafirDevices
          }, {
            path: 'search-all-requests',
            name: 'SearchAllRequests',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('AllRequests')
            },
            component: SearchAllRequests
          },
        ]
      },
      //* ***************************************************

      {
        path: '/product-request',
        name: i18n.t('ProductRequest'),
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: i18n.t('ProductRequest')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'factors/:rec_id',
            name: 'ProductRequestFactors',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('ProductRequest')
            },
            component: ProductFactors
          }, {
            path: 'factor-items/:rec_id',
            name: 'ProductRequestFactorItems',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('ProductRequest')
            },
            component: ProductFactorItems
          }, {
            path: 'add-pre-product',
            name: 'AddPreProduct',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: "افزودن کالای جدید"
            },
            component: AddPreProduct
          },
        ]
      },
      //* ***************************************************

      {
        path: '/buy-orders',
        name: i18n.t('BuyOrders'),
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name:  i18n.t('BuyOrders')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'list',
            name: 'BuyOrdersList',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name:  i18n.t('BuyOrders')
            },
            component: BuyOrders
          },{
            path: 'finalize',
            name: 'BuyOrdersFinalize',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: i18n.t('BuyOrderInvoice')
            },
            component: BuyOrdersFinalize
          },
        ]
      },
      {
        path: '/Morakhasi',
        name: "Morakhasi",
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name:  i18n.t('BuyOrders')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'list',
            name: 'MorakhasiList',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name:  'مرخصی ها'
            },
            component: MorakhasiComponent
          },{
            path: 'add-morakhasi',
            name: 'AddMorakhasi',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name: 'درخواست مرخصی'
            },
            component: AddMorakhasi
          },
        ]
      },
      {
        path: '/RequestPayReport',
        name: "RequestPayReport",
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name:  "گزارش پرداختی درخواست"
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'list',
            name: 'RequestPayReportList',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name:  'گزارش پرداختی درخواست'
            },
            component: RequestPayReport
          }
        ]
      },
      {
        path: '/wallet',
        name: 'Wallet',
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name: 'کیف پول'
        },
        component: Wallet
      },
//*****************************************
      {
        path: '/sipphone',
        redirect: '/sipphone/phone',
        meta: {
          requiresAuth: true,
          requiresPost: true,
          name:  i18n.t('BuyOrders')
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'phone',
            name: 'SipPhone',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: true,
              name:  'Sip Phone'
            },
            component: SipPhone
          },
        ]
      },

    ],

  },
]

const router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., back button), restore it
    if (savedPosition) {
      return savedPosition
    }
    // Otherwise scroll to top - return as Promise to ensure DOM is ready
    return new Promise((resolve) => {
      Vue.nextTick(() => {
        resolve({ x: 0, y: 0 })
      })
    })
  },
  routes
})

function validate_user (next, to) {
  const self = this
  const formData = new FormData()
  let url
  url = '/api/admin/validate-token'

  formData.append('token', localStorage.getItem('token'))

  axios.post(url, formData, {}).then((res) => {
    console.log('validate token is ' + res.data)

    if (res.data.validate) {
      console.log('validate is true')
      const meta_role = to.meta.requiresRole
      // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
      if (meta_role == null) {
        console.log('requiresRole is null')
        next()
      } else {
        console.log('requiresRole is ' + meta_role)
        const permissions = res.data.permissions
        if (permissions.includes(meta_role)) {
          console.log('user has permissions ')
          next()
        } else {
          next({
            path: '/dashboard/404',
            params: { nextUrl: to.fullPath }
          })
        }
      }
    } else {
      console.log('validate is false')

      next({
        path: '/dashboard/login',
      })
    }
    // return res.data;
  })

    // axios.post(  '/admin/category', {
    //     name: self.name,
    //     description: self.description,
    //     image: self.image,
    //     cat: 0,
    // }).then(function (response) {
    //     self.name = '';
    //     self.description = '';
    //     // localStorage.setItem("api_token", response.data.access_token);
    //     // self.$router.push({ path: 'notes' });
    // })
    .catch(function (error) {
      self.message = 'Incorrect E-mail or password'
      self.showMessage = true
      console.log(error)
    })
}

export default router

router.beforeEach((to, from, next) => {
  // console.log("before each" + " token is " + localStorage.getItem('token'));
  // console.log("before each"+next);
  // if (to.path == '/') {
  //   //  window.location.href = '/home';
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('phone') == null || localStorage.getItem('phone') == '') {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      // validate_user(next, to);
next()

      // let user = JSON.parse(localStorage.getItem('user'))
      // if(to.matched.some(record => record.meta.is_admin)) {
      //     if(user.is_admin == 1){
      //         next()
      //     }
      //     else{
      //         next({ name: 'userboard'})
      //     }
      // }else {
      //     next()
      // }
    }
  }
  if (to.matched.some(record => record.meta.requiresPost)) {
   if (localStorage.getItem('party_id') == null || localStorage.getItem('party_id') == '') {
      next({
        path: '/post-login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      // validate_user(next, to);
next()

      // let user = JSON.parse(localStorage.getItem('user'))
      // if(to.matched.some(record => record.meta.is_admin)) {
      //     if(user.is_admin == 1){
      //         next()
      //     }
      //     else{
      //         next({ name: 'userboard'})
      //     }
      // }else {
      //     next()
      // }
    }
  } else {
    next()
  }
})

// Scroll to top after each route change
router.afterEach(() => {
  // Use setTimeout to ensure DOM is fully rendered
  setTimeout(() => {
    // Scroll to top after navigation
    if (window && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0)
    }
    
    // Also try scrolling the main container/app if it exists
    if (document) {
      const appContainer = document.querySelector('#app')
      if (appContainer && typeof appContainer.scrollTo === 'function') {
        appContainer.scrollTo(0, 0)
      }
      
      // Scroll document elements
      if (document.documentElement) {
        document.documentElement.scrollTop = 0
      }
      if (document.body) {
        document.body.scrollTop = 0
      }
    }
  }, 100)
})
